import { Form, useMobile } from "@cpj-ai/panel-npm-package";
import { AuthAccountOrganizationStatusChoices } from "@graphql/generated";
import { Card } from "@heroui/react";
import { useOrganizationStore } from "@store/useOrganizationStore";
import { useForm } from "react-hook-form";
import { ICompanyInformationFormData, getInputConfigs } from "./formConfig";
import { useProfileFormData } from "./hooks/useProfileFormData";
import { useProfileSubmit } from "./hooks/useProfileSubmit";
interface ProfileInformationFormProps {
  setIsVerifyModalOpen: (isOpen: boolean) => void;
}
const ProfileInformationForm = ({ setIsVerifyModalOpen }: ProfileInformationFormProps) => {
  const { selectedOrganization, setSelectedOrganization } = useOrganizationStore();
  const formHandler = useForm<ICompanyInformationFormData>();
  const isMobile = useMobile();
  const { handleSubmit, reset } = formHandler;

  const formData = formHandler.getValues();

  useProfileFormData(selectedOrganization, reset);
  const { handleSaveProfile, loading } = useProfileSubmit(
    { id: selectedOrganization?.id ?? "", ...formHandler.getValues() },
    setSelectedOrganization,
  );

  const handleSave = () => {
    handleSaveProfile(formHandler.getValues());
    if (selectedOrganization?.status === AuthAccountOrganizationStatusChoices.DRAFTED) {
      setIsVerifyModalOpen(true);
    }
  };

  formHandler.watch("city");
  formHandler.watch("establishedAt");
  formHandler.watch("size");

  const Container = isMobile ? "div" : Card;

  return (
    <Container className="md:py-9 md:px-7 md:my-6 mx-7 md:mx-0 mt-6">
      <Form
        previewMode={
          !(
            selectedOrganization?.status === AuthAccountOrganizationStatusChoices.DRAFTED ||
            selectedOrganization?.status === AuthAccountOrganizationStatusChoices.COMPLETED
          )
        }
        formHandler={formHandler as any}
        inputConfigs={getInputConfigs(formData)}
        wrapInCard={false}
        showCancel={false}
        showSubmit={true}
        submitProps={{
          onClick: handleSubmit(handleSave),
          isLoading: loading,
          isDisabled: loading,
          children: loading ? "Saving..." : "Save",
        }}
      />
    </Container>
  );
};

export default ProfileInformationForm;
